import { API_RESPONSE } from './_const';
import { useDialogHandler } from './_dialogHandler';
import { useSpecialSubAccountApi } from './specialSubAccount';
import {
  decodeHomepagePictureConfig,
  parseBanner,
  parseContact,
  parseContactDetail,
  parseCreateOrderDefault,
  parseCreateOrderDefaultFour,
  parseCreateOrderDefaultThree,
  parseCreateOrderDefaultTwo,
  parseHomepagePictureConfig,
  parseMember,
  parseMemberDetail,
  parseNews,
  parseNewsConfig,
  parseOrderComment,
  parseOrderInfo,
  parseOrderRecord,
  parseMonthFeeSettingList,
  parseOrderStatusLog,
  parseServiceArea,
  parsePreorderList,
  parseOrderContact,
  parseMonthlyFee,
  parseFeeDetail,
} from './_responseParser';

const useAPIMethods = ({ axios, dialogHandler }) => {
  const dialog = useDialogHandler(dialogHandler);

  const updateToken = (token) => {
    axios.updateToken(token);
  };

  const login = (
    { account, password, browserInfo } = {
      account: '',
      password: '',
      browserInfo:
        'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.106 Mobile Safari/537.36 Edg/91.0.864.53',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = { account, password, browser_info: browserInfo };

      axios
        .post('Account/AccessLogin', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsedResponse = {
              sessionToken: response.data.session_token,
              memberID: response.data.member_id,
              accountCode: response.data.account_code,
              isAdmin: response.data.is_admin,
            };
            resolve(parsedResponse);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const searchAccountMonthFee = (
    { createDate, endDate } = {
      createDate: '',
      endDate: '',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = { start_date: createDate, end_date: endDate };
      axios
        .post('Fee/settings/list', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsedResponse = [];
            for (const fee of response.data) {
              parsedResponse.push(parseMonthFeeSettingList(fee));
            }
            resolve(parsedResponse);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const deleteActivity = ({ activityId } = { activityId: 0 }) =>
    new Promise((resolve, reject) => {
      const parameters = {
        activity_id:
          (Number.isNaN(+activityId) ? activityId : +activityId) || 0,
      };

      axios
        .post('Fee/settings/delete', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const forgetPassword = (
    { accountCode, email, browserInfo } = {
      accountCode: 'Robert@gmail.com',
      email: '123@tooFast',
      browserInfo:
        'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.106 Mobile Safari/537.36 Edg/91.0.864.53',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        account_code: accountCode,
        email,
        browser_info: browserInfo,
      };

      axios
        .post('Account/CheckMemberExistOrNot', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const resetPassword = (
    { newPassword, confirmPassword, validToken } = {
      newPassword: 'Robert@gmail.com',
      confirmPassword: '123@tooFast',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        new_password: newPassword,
        confirm_password: confirmPassword,
        valid_token: validToken,
      };
      axios
        .post('Account/ResetPassword', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const auth = () =>
    new Promise((resolve, reject) => {
      axios
        .post('Account/CheckToken')
        .then((response) => {
          if (!response || !response.data) {
            throw { message: '很抱歉，發生未知的錯誤。' };
          }

          const parsedResponse = {
            sessionToken: response.data.session_token,
          };

          resolve(parsedResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });

  const register = (
    {
      // account_code,
      companyName,
      email,
      mobile,
      companyTel,
      companyTelCity,
      companyTelExt,
      city,
      district,
      address,
      personInCharge,
      // password,
      paymentMethod,
      taxID,
      bankCode,
      // bank_name,
      bankAccount,
      isAgreementChecked,
      industryType,
    } = {
      // account_code: 'testaccout',
      companyName: '光年科技2',
      email: 'zyjeng@light-year.tech',
      mobile: '0987654321',
      companyTel: '12345678',
      companyTelCity: '02',
      companyTelExt: '888',
      city: '台北市',
      district: '大安區',
      address: '羅斯福路',
      personInCharge: '增脂魚',
      // password: 'asdfghjkl',
      paymentMethod: '1',
      taxID: '12345678',
      bankCode: '404',
      // bank_name: '找不到銀行',
      bankAccount: '0000000000',
      isAgreementChecked: true,
      industryType: 'A',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        district: Number.parseInt(district) || 0, // 行政區(區域)
        bank_account: bankAccount || '', // 銀行帳戶
        bank_code: bankCode || '', // 銀行代碼
        city: city || '', // 行政區(縣市)
        company_name: companyName || '', // 公司名稱
        company_tel: companyTel || '', // 公司電話(主要)
        company_tel_city: companyTelCity || '', // 公司電話(區碼)
        company_tel_ext: companyTelExt || '', // 公司電話(分機)
        email: email || '', // 信箱
        is_agreement_checked: isAgreementChecked || false, // 已同意會員合約和隱私權聲明
        mobile: mobile || '', // 行動電話
        paid_method: paymentMethod || '', // 支付方式
        person_in_chage: personInCharge || '', // 負責人
        address: address || '', // 地址
        tax_id: taxID || '', // 統一編號
        industry_type: industryType || '',
      };

      axios
        .post('Account/SaveNewMember', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getHomepageBanners = () =>
    new Promise((resolve, reject) => {
      axios
        .post('BackstageIndex/GetBackageIndexPictures')
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsedBanners = [];

            for (const banner of response.data) {
              parsedBanners.push(parseBanner(banner));
            }

            resolve(parsedBanners);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getHomepageNews = () =>
    new Promise((resolve, reject) => {
      axios
        .post('BackstageIndex/GetBackageIndexNews')
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsedNewsList = [];

            for (const news of response.data) {
              parsedNewsList.push(parseNews(news));
            }

            resolve(parsedNewsList);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getDropdownCitys = () =>
    new Promise((resolve, reject) => {
      axios
        .get('DropDownList/GetCityAndArea')
        .then((response) => {
          if (
            response.code === API_RESPONSE.SUCCESS &&
            response.data.length > 0
          ) {
            resolve(response.data.filter((city) => city.text && city.value));
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getMembersDropDownList = () =>
    new Promise((resolve, reject) => {
      axios
        .post('Order/GetMembersDropDownList')
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOneMember = ({ memberID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };

      axios
        .post('Order/GetOneMember', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS && response.data) {
            const data = response.data;
            resolve({
              accountCode: data.account_code,
              name: data.name,
            });
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getDropdownPaymentMethods = (
    { isCreatingMember } = { isCreatingMember: false }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = { type: isCreatingMember ? 1 : 0 };

      axios
        .post('DropDownList/GetPaymentMethodDropDown', parameters)
        .then((response) => {
          if (
            response.code === API_RESPONSE.SUCCESS &&
            response.data.length > 0
          ) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getDropdownShippingRates = () =>
    new Promise((resolve, reject) => {
      axios
        .get('DropDownList/GetShippingRateList')
        .then((response) => {
          if (
            response.code === API_RESPONSE.SUCCESS &&
            response.data.length > 0
          ) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getIndustryTypes = () =>
    new Promise((resolve, reject) => {
      axios
        .get('DropDownList/GetIndustryType')
        .then((response) => {
          if (
            response.code === API_RESPONSE.SUCCESS &&
            response.data.length > 0
          ) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getMemberTypes = () =>
    new Promise((resolve, reject) => {
      axios
        .get('DropDownList/GetMemberType')
        .then((response) => {
          if (
            response.code === API_RESPONSE.SUCCESS &&
            response.data.length > 0
          ) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getDropdownBankCodes = () =>
    new Promise((resolve, reject) => {
      axios
        .get('DropDownList/GetBankDropDown')
        .then((response) => {
          if (
            response.code === API_RESPONSE.SUCCESS &&
            response.data.length > 0
          ) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const deleteMember = ({ memberID } = { memberID: 4942 }) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };
      axios
        .post('member/delete', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getMemberList = (
    { accountCode, address, abbreviation, tel, taxID, districtID } = {
      accountCode: '',
      address: '',
      abbreviation: '',
      tel: '',
      taxID: '',
      districtID: 0,
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        account_code: accountCode || '',
        address: address || '',
        abbreviation: abbreviation || '',
        tel: tel || '',
        tax_id: taxID || '',
        district_id: Number.parseInt(districtID) || 0,
      };

      axios
        // .post('Member/SearchMember/GetMemberDefaultData', parameters)
        .post('Member/SearchMember', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsedMembers = [];
            for (const originMember of response.data) {
              const parsedMember = parseMember(originMember);
              parsedMembers.push(parsedMember);
            }
            resolve(parsedMembers);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getMemberDetail = ({ memberID } = { memberID: 4942 }) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };
      axios
        .post('Member/GetMemberDetialById', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const origin = response.data;
            if (!origin) {
              throw response;
            }
            const parsedMember = parseMemberDetail(origin);
            resolve(parsedMember);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const updateMemberDetail = ({ data }) =>
    new Promise((resolve, reject) => {
      if (!data) {
        dialog.openAlert({ message: '輸入參數錯誤' });
        reject();
      }

      const parameters = {
        member_id: Number.parseInt(data.member_id),
        member: {
          abbreviation: data.abbreviation || '',
          memberTypeCode: data.memberType || '',
          industryTypeCode: data.industryType || '',
          company_name: data.title || '',
          owner: data.personInCharge || '',
          district_id: Number.parseInt(data.district) || 0,
          street_address: data.address || '',
          website: data.website || '',
          email: data.email || '',
          password: data.password || '',
          mobile_phone_number: data.mobile || '',
          phone_number: data.telPhone || '',
          phone_number_city_code: data.areaCode || '',
          phone_number_ext: data.extensionNumber || '',
          note: data.remark || '',
        },
        payment: {
          payment_method: Number.parseInt(data.paymentMethod) || 0,
          responsible_accountant: data.accountingInCharge || '',
          receivable_category: data.accountReceivable || '',
          discount_amount: Number.parseInt(data.disscount) || 0,
          shipping_rate_list_id: Number.parseInt(data.rateTable) || 0,
          invoice_date: data.requestDate || '',
          settlement_date: data.checkoutDate || '',
          bank_swift_code: data.bankCode || '',
          bank_account: data.bankAccount || '',
          tax_id: data.taxNumber || '',
        },
      };

      axios
        .post('Member/EditMemberDetailData', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const createNewMember = ({ data }) =>
    new Promise((resolve, reject) => {
      if (!data) {
        dialog.openAlert({ message: '輸入參數錯誤' });
        reject();
      }

      const parameters = {
        member: {
          abbreviation: data.abbreviation,
          member_type_code: data.memberType,
          industry_type_code: data.industryType,
          company_name: data.title,
          owner: data.personInCharge,
          district_id: Number.parseInt(data.district),
          street_address: data.address,
          website: data.website,
          email: data.email,
          mobile_phone_number: data.mobile,
          phone_number: data.telPhone,
          phone_number_city_code: data.areaCode,
          phone_number_ext: data.extensionNumber,
          note: data.remark,
        },
        payment: {
          payment_method: Number.parseInt(data.paymentMethod),
          responsible_accountant: data.accountingInCharge,
          receivable_category: data.accountReceivable,
          discount_amount: Number.parseInt(data.disscount),
          shipping_rate_list_id: Number.parseInt(data.rateTable),
          invoice_date: data.requestDate,
          settlement_date: data.checkoutDate,
          bank_swift_code: data.bankCode,
          bank_account: data.bankAccount,
          tax_id: data.taxNumber,
        },
      };

      axios
        .post('Member/NewMember', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getInvoiceType = () =>
    new Promise((resolve, reject) => {
      const parameters = {};
      axios
        .post('Order/GetInvoiceType', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOrderStatusDropDownList = () =>
    new Promise((resolve, reject) => {
      const parameters = {};
      axios
        .post('Order/GetOrderStatusDropDownList', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOrderDeliveryMethods = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('Order/GetOrderDeliveryMethods', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getPrintStatus = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('Order/GetPrintStatus', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const deleteOrder = (
    { orderID } = {
      orderID: '',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        order_id: orderID || '',
      };
      axios
        .post('Order/Delete', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const reassignOrder = (
    { orderID } = {
      orderID: '',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        no: orderID || '',
      };
      axios
        .post('Order/Reassign', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const saveInDepot = (
    { orderID } = {
      orderID: '',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        no: orderID || '',
      };
      axios
        .post('Order/SaveInDepot', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOrdersByFilter = (
    {
      orderID,
      orderStatus,
      memberID,
      createTime,
      printStatus,
      pickupTime,
      contactName,
      accountCode,
      address,
      phone,
      paymentMethod,
    } = {
      orderID: '',
      orderStatus: '',
      memberID: '',
      createTime: '',
      printStatus: '',
      pickupTime: '',
      contactName: '',
      accountCode: '',
      address: '',
      phone: '',
      paymentMethod: '',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        order_id: orderID || '',
        order_status: orderStatus || '',
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
        account_code: accountCode || '',
        create_time: createTime || '',
        is_print: printStatus || '',
        pick_up_datetime: pickupTime || '',
        contact_name: contactName || '',
        address: address || '',
        phone: phone || '',
        payment_method: paymentMethod || '',
      };

      axios
        .post('Order/GetOrdersByFilter', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsed = [];
            for (const order of response.data) {
              parsed.push(parseOrderRecord(order));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getDefaultOrdersByMemberID = ({ memberID } = { memberID: '123' }) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };

      axios
        .post('Order/Get7DaysOrdersByMemberId', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsed = [];
            for (const order of response.data) {
              parsed.push(parseOrderRecord(order));
            }

            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getEditOrderByOrderId = ({ id } = { id: '123' }) =>
    new Promise((resolve, reject) => {
      const parameters = { no: id };

      axios
        .post('Order/GetEditOrderByOrderId', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOrderStatusLog = ({ id } = { id: '123' }) =>
    new Promise((resolve, reject) => {
      const parameters = { no: id };

      axios
        .post('Order/SearchOrderLog', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsed = [];
            for (const statusLog of response.data) {
              parsed.push(parseOrderStatusLog(statusLog));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const saveComment = (
    {
      commentID,
      orderID,
      commentStars,
      commentText,
      pictureString,
      pictureName,
      modificationTimes,
    } = {
      commentID: 0,
      orderID: '',
      commentStars: 0,
      commentText: '',
      pictureString: '',
      pictureName: '',
      modificationTimes: 0,
    }
  ) =>
    new Promise((resolve, reject) => {
      let imgString = '';
      if (pictureString.includes('https')) {
        imgString = pictureString;
      } else {
        const arrayImage = pictureString.split(',');
        imgString = arrayImage[1];
      }

      const parameters = {
        id: commentID,
        order_id: orderID,
        comment_stars: commentStars,
        comment_text: commentText,
        picture_string: imgString,
        picture_name: pictureName,
        modification_times: modificationTimes,
      };

      axios
        .post('Order/SaveComment', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getComment = ({ id } = { id: 0 }) =>
    new Promise((resolve, reject) => {
      const parameters = { no: id };

      axios
        .post('Order/GetComment', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(parseOrderComment(response.data));
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getHomepagePictureConfigs = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('BackstageIndex/GetEditedPictures', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsed = [];
            for (const config of response.data) {
              parsed.push(parseHomepagePictureConfig(config));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const saveHomepagePictureConfigs = (
    { data } = {
      data: [
        {
          id: 0,
          title: '',
          link: '',
          pictureString: '',
          pictureName: '',
          display: false,
        },
      ],
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = [];
      for (const config of data) {
        parameters.push(decodeHomepagePictureConfig(config));
      }

      axios
        .post('BackstageIndex/SavePictures', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getNewsTypeDropDownList = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('BackstageIndex/GetNewsTypeDropDownList', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getContacts = ({ memberID } = { memberID: 1 }) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };

      axios
        .post('ContactsDirectory/GetContactDirectory', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const contacts =
              response.data && response.data ? response.data.contacts_data : [];

            const parsed = [];
            for (const contact of contacts) {
              parsed.push(parseContact(contact));
            }

            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOrderList = (
    { memberID, accountCode, abbreviation, districtID, address, phone } = {
      memberID: -1,
      accountCode: '',
      abbreviation: '',
      districtID: 0,
      address: '',
      phone: '',
    }
  ) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
        account_code: accountCode,
        abbreviation: abbreviation,
        district_id: districtID,
        address: address,
        phone: phone,
      };

      axios
        .post('Member/SearchMemberList', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS && response.data) {
            const parsed = [];
            for (const order of response.data) {
              parsed.push(parseOrderInfo(order));
            }

            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getNewsConfig = () =>
    new Promise((resolve, reject) => {
      const parameters = {};
      axios
        .post('BackstageIndex/GetEditedNews', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsed = [];
            for (const config of response.data) {
              parsed.push(parseNewsConfig(config));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const updateNewsConfig = (
    data = [
      {
        id: 0,
        news_type: '',
        content: '',
        display: false,
      },
    ]
  ) =>
    new Promise((resolve, reject) => {
      const parameters = [];
      for (const row of data) {
        parameters.push({
          id: row.id,
          news_type: row.newsType,
          content: row.content,
          display: row.display,
        });
      }

      axios
        .post('BackstageIndex/SaveNews', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getCreateOrderStepOneDefault = ({ memberID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };

      axios
        .post('Order/CreateOrderStepOneDefault', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS && response.data) {
            const parsedData = parseCreateOrderDefault(response.data);
            if (!parsedData) throw response;
            resolve(parsedData);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const submitCreateOrderStepOne = ({
    memberID,
    contactID,
    company,
    contact,
    phoneAreaCode,
    phone,
    phoneExt,
    mobile,
    isMobilePhone,
    districtID,
    address,
    pickupTime,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
        contact_id: contactID,
        company: company,
        contact: contact,
        phone_area_code: phoneAreaCode,
        phone: phone,
        phone_ext: phoneExt,
        mobile: mobile,
        is_mobile_phone: isMobilePhone,
        district_id: districtID,
        address: address,
        pick_up_time: pickupTime,
      };

      axios
        .post('Order/CreateOrderStepOneSubmit', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getCreateOrderStepTwoDefault = ({ memberID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };

      axios
        .post('Order/CreateOrderStepTwoDefault', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS && response.data) {
            const parsedData = parseCreateOrderDefaultTwo(response.data);
            if (!parsedData) throw response;
            resolve(parsedData);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getCreateOrderStepTwoDeliveryTime = ({
    deliveryMethod,
    receiveDistrict,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        delivery_method:
          (Number.isNaN(+deliveryMethod) ? deliveryMethod : +deliveryMethod) ||
          0,
        receive_district:
          (Number.isNaN(+receiveDistrict)
            ? receiveDistrict
            : +receiveDistrict) || 0,
      };

      axios
        .post('Order/CreateOrderStepTwoDeliveryDateTimeCalculator', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else resolve(false);
        })
        .catch((error) => {
          reject(error);
        });
    });

  const submitCreateOrderStepTwo = ({
    contactID,
    company,
    contact,
    phoneAreaCode,
    phone,
    phoneExt,
    mobile,
    isMobilePhone,
    districtID,
    address,
    receiveTime,
    deliveryMethod,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        contact_id: contactID,
        company: company,
        contact: contact,
        phone_area_code: phoneAreaCode,
        phone_number: phone,
        phone_ext: phoneExt,
        mobile: mobile,
        is_mobile: isMobilePhone,
        district_id: districtID,
        address: address,
        receive_time: receiveTime,
        delivery_method: deliveryMethod,
      };

      axios
        .post('Order/CreateOrderStepTwoSubmit', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getCreateOrderStepThreeDefault = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('Order/CreateOrderStepThreeDefault', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS && response.data) {
            const parsedData = parseCreateOrderDefaultThree(response.data);
            if (!parsedData) throw response;
            resolve(parsedData);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getCreateOrderStepThreeFee = ({
    memberID,
    paymentMethod,
    agencyReceiptAmount,
    prePaidAmount,
    insuranceAmount,
    weightID,
    cbmID,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
        payment_method: paymentMethod,
        agency_receipt_amount: agencyReceiptAmount,
        prepaid_amount: prePaidAmount,
        insurance_amouunt: insuranceAmount,
        weight_id: weightID,
        cbm_id: cbmID,
      };

      axios
        .post('Order/CreateOrderStepThreeShippingFeeCalculator', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const origin = response.data;
            const parsed = {
              shippingFee: origin.shipping_fee,
              tax: origin.tax,
              totalAmount: origin.total,
            };
            resolve(parsed);
          } else resolve(false);
        })
        .catch((error) => {
          reject(error);
        });
    });

  const submitCreateOrderStepThree = ({
    submitEmail,
    specialSubAccount,
    paymentMethodID,
    taxID,
    invoiceType,
    agencyReceiptAmount,
    prePaidAmount,
    weightID,
    cbmID,
    productPrice,
    deliveryNote,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        submit_email: submitEmail,
        special_sub_account: specialSubAccount,
        payment_method_id: paymentMethodID,
        tax_id: taxID,
        invoice_type: invoiceType,
        agency_receipt_amount: agencyReceiptAmount,
        pre_paid_amount: prePaidAmount,
        weight_id: weightID,
        cbm_id: cbmID,
        product_price:
          (Number.isNaN(+productPrice) ? productPrice : +productPrice) || 0,
        delivery_note: deliveryNote,
      };

      axios
        .post('Order/CreateOrderStepThreeSubmit', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.data });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getCreateOrderStepFourDefault = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('Order/CreateOrderStepFourDefault', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS && response.data) {
            const parsedData = parseCreateOrderDefaultFour(response.data);
            if (!parsedData) throw response;
            resolve(parsedData);
          } else {
            dialog.openAlert({ message: response.message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getPhoneTypes = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('ContactsDirectory/GetPhoneType', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getServiceAreaList = () =>
    new Promise((resolve, reject) => {
      const parameters = {};

      axios
        .post('ContactsDirectory/GetServiceArea', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            if (!response.data) return [];
            const parsed = [];
            for (const [index, item] of response.data.entries()) {
              parsed.push(parseServiceArea(item, index + 1));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getOrderContacts = ({ memberID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
      };

      axios
        .post('Order/GetContacts', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            if (!response.data) return [];
            const parsed = [];
            for (const item of response.data) {
              parsed.push(parseOrderContact(item));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const submitCreateNewContact = ({
    memberID,
    contactPerson,
    company,
    department,
    isEmployee,
    phoneNumber,
    secondPhoneNumber,
    districtID,
    address,
    serviceAreaID,
    note,
    email,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: (Number.isNaN(+memberID) ? memberID : +memberID) || 0,
        name: contactPerson,
        email,
        phone: phoneNumber,
        secondPhone: secondPhoneNumber,
        department,
        note,
        company,
        is_employee: isEmployee,
        district_id:
          (Number.isNaN(+districtID) ? districtID : +districtID) || 0,
        street_address: address,
        service_area_id:
          (Number.isNaN(+serviceAreaID) ? serviceAreaID : +serviceAreaID) || 11,
      };

      axios
        .post('ContactsDirectory/Create', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            if (response.data && response.data.length > 0) {
              const dataMessage = response.data.join('\n');
              dialog.openAlert({ message: dataMessage });
            } else {
              dialog.openAlert({ message: response.message });
            }

            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const updateContactDetail = ({
    contactID,
    contactPerson,
    company,
    department,
    isEmployee,
    phoneNumber,
    secondPhoneNumber,
    districtID,
    address,
    serviceAreaID,
    note,
    email,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        contact_id: (Number.isNaN(+contactID) ? contactID : +contactID) || 0,
        name: contactPerson,
        email,
        phone: phoneNumber,
        secondPhone: secondPhoneNumber,
        department,
        note,
        company,
        is_employee: isEmployee,
        district_id:
          (Number.isNaN(+districtID) ? districtID : +districtID) || 0,
        street_address: address,
        service_area_id:
          (Number.isNaN(+serviceAreaID) ? serviceAreaID : +serviceAreaID) || 11,
      };

      axios
        .post('ContactsDirectory/Edit', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            if (response.data && response.data.length > 0) {
              const dataMessage = response.data.join('\n');
              dialog.openAlert({ message: dataMessage });
            } else {
              dialog.openAlert({ message: response.message });
            }
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const deleteContact = ({ contactID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        contact_id: (Number.isNaN(+contactID) ? contactID : +contactID) || 0,
      };

      axios
        .post('ContactsDirectory/DeleteConfirmed', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const setMainContact = ({ contactID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        contact_id: (Number.isNaN(+contactID) ? contactID : +contactID) || 0,
      };

      axios
        .post('ContactsDirectory/SetMainContact', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getContactDetail = ({ contactID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        contact_id: (Number.isNaN(+contactID) ? contactID : +contactID) || 0,
      };

      axios
        .post('ContactsDirectory/GetDetails', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(parseContactDetail(response.data));
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  const updateOrderRecord = (parameters) =>
    new Promise((resolve, reject) => {
      axios
        .post('Order/UpdateOrder', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getPreOrderList = (memberID) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: Number.parseInt(memberID),
      };
      axios
        .post('order/preorderlist', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            if (!response.data) return [];
            const parsed = [];
            for (const item of response.data) {
              parsed.push(parsePreorderList(item));
            }
            resolve(parsed);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const uploadOrderFile = (fileOrder, member_id) =>
    new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', fileOrder);
      formData.append('member_id', member_id);
      axios
        .post('Order/UploadExcel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const downloadOrderFile = (memberID) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: Number.parseInt(memberID),
      };
      axios
        .post('Order/DownloadExcel', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const updatePrintStatus = (arrayOrder) =>
    new Promise((resolve, reject) => {
      axios
        .post('Order/IsPrint', arrayOrder)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getFeeMonthly = ({
    memberId,
    accountCode,
    name,
    startDate,
    endDate,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: memberId,
        account_code: accountCode,
        name: name,
        start_date: startDate,
        end_date: endDate,
      };

      axios
        .post('Fee/list', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            const parsedFees = [];
            for (const originFee of response.data) {
              const parsedFee = parseMonthlyFee(originFee);
              parsedFees.push(parsedFee);
            }
            resolve(parsedFees);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          resolve(error);
          reject(error);
        });
    });

  const downloadMonthlyFeeFile = ({
    memberId,
    accountCode,
    name,
    startDate,
    endDate,
  } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: memberId,
        account_code: accountCode,
        name: name,
        start_date: startDate,
        end_date: endDate,
      };

      axios
        .post('Fee/lit/export', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const addRelatedMember = (memberId, accountCode) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: Number.parseInt(memberId),
        account_code: accountCode,
      };
      axios
        .post('Member/settings/related/add', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const removeRelatedMember = (memberId, accountCode) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: Number.parseInt(memberId),
        account_code: accountCode,
      };
      axios
        .post('Member/settings/related/delete', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getRelatedMember = ({ memberID } = {}) =>
    new Promise((resolve, reject) => {
      const parameters = {
        member_id: Number.parseInt(memberID),
      };
      axios
        .post('Member/settings/related/list', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // new Promise((resolve, reject) => {
  //   axios
  //     .post('Fee/list')
  //     .then((response) => {
  //       if (response.code === API_RESPONSE.SUCCESS) {
  //         resolve();
  //       } else {
  //         dialog.openAlert({ message: response.message });
  //         resolve(false);
  //       }
  //     })
  //     .catch((error) => {
  //       reject(error);
  //     });
  // });
  // };

  const getFeeDetail = (activityId) =>
    new Promise((resolve, reject) => {
      const parameters = {
        activity_id: Number.parseInt(activityId),
      };
      axios
        .post('Fee/settings/data', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(parseFeeDetail(response.data));
          } else {
            dialog.openAlert({ message: response.message });
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const getFeeMemberMenu = (activityId) =>
    new Promise((resolve, reject) => {
      const parameters = {
        activity_id: Number.parseInt(activityId),
      };
      axios
        .post('Fee/settings/member/menu', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve(response.data);
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const updateFee = (parameters) =>
    new Promise((resolve, reject) => {
      axios
        .post('Fee/settings/edit', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const saveFee = (parameters) =>
    new Promise((resolve, reject) => {
      axios
        .post('Fee/settings/insert', parameters)
        .then((response) => {
          if (response.code === API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            dialog.openAlert({ message: response.message });
            throw response;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  const fetchCaseImage = (sessionToken, orderId) =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.open('GET', `/api/Remote/FetchCaseImage?orderId=${orderId}`);
      xhr.setRequestHeader('Authorization', `Bearer ${sessionToken}`);
      xhr.setRequestHeader('Accept', 'image/*');
      xhr.send();
      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          const reader = new FileReader();
          reader.readAsDataURL(xhr.response);
          reader.onloadend = () => {
            resolve(reader.result);
          };
        } else {
          reject('not found');
        }
      });
      xhr.addEventListener('error', () => {
        reject('not found');
      });
    });

  return {
    axios,
    updateToken,
    login,
    forgetPassword,
    resetPassword,
    auth,
    register,
    getHomepageBanners,
    getHomepageNews,
    getDropdownCitys,
    getDropdownPaymentMethods,
    getDropdownBankCodes,
    getDropdownShippingRates,
    getIndustryTypes,
    getMemberTypes,
    getMemberList,
    getMemberDetail,
    updateMemberDetail,
    createNewMember,
    deleteMember,
    getInvoiceType,
    getOrderStatusDropDownList,
    getOrderDeliveryMethods,
    getPrintStatus,
    getDefaultOrdersByMemberID,
    getOrdersByFilter,
    getEditOrderByOrderId,
    getOrderStatusLog,
    saveComment,
    getComment,
    getNewsConfig,
    updateNewsConfig,
    updateOrderRecord,
    getHomepagePictureConfigs,
    saveHomepagePictureConfigs,
    getNewsTypeDropDownList,
    getContacts,
    getOrderList,
    deleteOrder,
    reassignOrder,
    saveInDepot,
    getCreateOrderStepOneDefault,
    submitCreateOrderStepOne,
    getCreateOrderStepTwoDefault,
    getCreateOrderStepTwoDeliveryTime,
    submitCreateOrderStepTwo,
    getCreateOrderStepThreeDefault,
    getCreateOrderStepThreeFee,
    submitCreateOrderStepThree,
    getCreateOrderStepFourDefault,
    getPhoneTypes,
    getServiceAreaList,
    submitCreateNewContact,
    updateContactDetail,
    deleteContact,
    setMainContact,
    getContactDetail,
    getPreOrderList,
    getMembersDropDownList,
    getOneMember,
    getOrderContacts,
    uploadOrderFile,
    downloadOrderFile,
    updatePrintStatus,
    getFeeMonthly,
    downloadMonthlyFeeFile,
    searchAccountMonthFee,
    deleteActivity,
    getFeeDetail,
    getFeeMemberMenu,
    saveFee,
    updateFee,
    addRelatedMember,
    removeRelatedMember,
    getRelatedMember,
    fetchCaseImage,
    specialSubAccountApi: useSpecialSubAccountApi({ axios }),
  };
};

export { useAPIMethods };
